import React, { useState } from 'react';
import styled from 'styled-components';
import { getDatabase, ref, get } from 'firebase/database';
import { app } from '../firebase';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f5f5f5;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  max-width: 400px;
  width: 100%;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const Title = styled.h1`
  font-family: 'Cormorant Garamond', serif;
  color: #333;
  margin: 0;
  text-align: center;
`;

const Subtitle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  letter-spacing: 1px;
  color: #666;
  text-transform: uppercase;
  margin-top: -0.5rem;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const Input = styled.input`
  width: 100%;
  padding: 1rem;
  padding-right: 3rem;
  border: 2px solid #eee;
  border-radius: 4px;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #333;
  }
`;

const TogglePasswordButton = styled.button`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0.5rem;
  color: #666;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;

  &:hover {
    color: #333;
  }

  &:focus {
    outline: none;
  }
`;

const Button = styled.button`
  padding: 1rem 2rem;
  background: #333;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
  font-family: 'Montserrat', sans-serif;

  &:hover {
    background: #444;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #f44336;
  font-size: 0.9rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
`;

const AdminPasswordGate = ({ onCorrectPassword }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const verifyPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const db = getDatabase(app);
      const passwordRef = ref(db, 'adminPassword');
      const snapshot = await get(passwordRef);

      if (snapshot.exists()) {
        const correctPassword = snapshot.val();
        if (password === correctPassword) {
          localStorage.setItem('adminPasswordVerified', 'true');
          onCorrectPassword();
        } else {
          setError('Incorrect password. Please try again.');
        }
      } else {
        setError('Unable to verify password. Please try again later.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
      console.error('Error verifying admin password:', error);
    }

    setIsLoading(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container>
      <Form onSubmit={verifyPassword}>
        <Title>Admin Access</Title>
        <Subtitle>HANA & DAVID'S WEDDING</Subtitle>
        <InputContainer>
          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Enter Admin Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
          />
          <TogglePasswordButton
            type="button"
            onClick={togglePasswordVisibility}
            tabIndex={-1}
          >
            {showPassword ? "Hide" : "Show"}
          </TogglePasswordButton>
        </InputContainer>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <Button type="submit" disabled={!password || isLoading}>
          {isLoading ? 'Verifying...' : 'Enter'}
        </Button>
      </Form>
    </Container>
  );
};

export default AdminPasswordGate;
